
  import { defineComponent, PropType } from 'vue';
  import { createColumnHelper } from '@tanstack/vue-table';

  import TableAggregated from '@/common/components/redesigned/Table/TableAggregated.vue';
  import {
    TPaginationConfig,
    TTableAggregatedProgressBarOptions,
  } from '@/common/components/redesigned/Table/types/tableTypes';
  import text from '@/common/mixins/text';

  import { PAGINATION_CONFIG } from '../../constants/pagination';
  import { TABLE_AGGREGATED_PROGRESS_BAR_OPTIONS } from '../../constants/tableAggregatedProgress';
  import {
    PRODUCT_AGGREGATED_ACTIONS_NAME,
    PRODUCT_AGGREGATED_GETTERS_NAME,
    PRODUCT_AGGREGATED_MUTATIONS_NAME,
  } from '../../store/productAggregated/name';
  import {
    TProductAggregatedFilter,
    TProductAggregatedItem,
    TProductAggregatedTableData,
  } from '../../types/product-aggregated';
  import { getCodeCell, getProductNameCell } from '../../utils/table';

  export default defineComponent({
    name: 'ProductAggregatedTable',
    components: {
      TableAggregated,
    },
    mixins: [text],
    props: {
      filter: {
        type: Object as PropType<TProductAggregatedFilter>,
        required: true,
      },
    },
    data() {
      return {
        storePaths: {
          action: PRODUCT_AGGREGATED_ACTIONS_NAME.searchProductAggregated,
          getter: PRODUCT_AGGREGATED_GETTERS_NAME.getProductAggregated,
          mutation: PRODUCT_AGGREGATED_MUTATIONS_NAME.setProductAggregated,
        },
      };
    },
    computed: {
      getPaginationConfig(): TPaginationConfig {
        return PAGINATION_CONFIG;
      },
      getProgressBarOptions(): TTableAggregatedProgressBarOptions {
        return TABLE_AGGREGATED_PROGRESS_BAR_OPTIONS;
      },
    },
    methods: {
      generateColumns(data: TProductAggregatedTableData) {
        if (!data) return [];

        const columnHelper = createColumnHelper<TProductAggregatedItem>();

        return [
          // Поставил игнорирования из-за того, что в браузере вылезает ошибка типа (после обновления ts должна уйти)
          // @ts-ignore
          getCodeCell(columnHelper),
          // @ts-ignore
          getProductNameCell(columnHelper),
          ...data.periods.map((period, index) => {
            return columnHelper.group({
              header: period,
              id: `${period}${index}`,
              columns: [
                columnHelper.group({
                  header: 'Экспорт',
                  columns: [
                    columnHelper.accessor(
                      (row: TProductAggregatedItem) => this.formatNumber(row.indicators[index]?.export.weight, 1),
                      {
                        header: 'Вес, тонн',
                        id: `export-weight-${index}`,
                        size: 160,
                      },
                    ),
                    columnHelper.accessor(
                      (row: TProductAggregatedItem) => this.formatNumber(row.indicators[index]?.export.price, 1),
                      {
                        header: 'Стоимость, тыс. долл.',
                        id: `export-price-${index}`,
                        size: 160,
                      },
                    ),
                  ],
                }),
                columnHelper.group({
                  header: 'Импорт',
                  columns: [
                    columnHelper.accessor(
                      (row: TProductAggregatedItem) => this.formatNumber(row.indicators[index]?.import.weight, 1),
                      {
                        header: 'Вес, тонн',
                        id: `import-weight-${index}`,
                        size: 160,
                      },
                    ),
                    columnHelper.accessor(
                      (row: TProductAggregatedItem) => this.formatNumber(row.indicators[index]?.import.price, 1),
                      {
                        header: 'Стоимость, тыс. долл.',
                        id: `import-price-${index}`,
                        size: 160,
                      },
                    ),
                  ],
                }),
              ],
            });
          }),
        ];
      },
    },
  });
